// Search for an Ant Design <Select showSearch>: matches what is typed against
// what the user sees. By default Select searches the option's VALUE, which is
// an ID on most of our pickers, so typing a name found nothing. This looks at
// the label (or an <Option>'s children), plain text or the text inside an
// element, and the value too, so nothing that matched before stops matching.
const textOf = (node) => {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(textOf).join(' ');
  if (node.props) return textOf(node.props.children);
  return '';
};

export function selectFilter(input, option) {
  const q = (input || '').trim().toLowerCase();
  if (!q) return true;
  return [option?.label, option?.children, option?.value]
    .some((v) => textOf(v).toLowerCase().includes(q));
}
